import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import GlobalDialogContent from "../../GlobalDialogContent";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import { SewaCategoryListService, SewaDalStoreService, SewaDalUpdateService } from "../../../../utils/services/sewa-master.service";
import { showSnackbar } from "../../../../redux/reducer/snackbarSlice";
import { closeDialog } from "../../../../redux/reducer/dialogSlice";
import { setModuleRefresh } from "../../../../redux/reducer/registration/RefreshSlice";
import { Send } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { GetPincodeDetailsService } from "../../../../utils/services/registration/donor-registration.service";

const AddSewaDal = () => {
    const payload = useSelector((state: any) => state.dialog?.payload);
    const dispatch = useDispatch();
    const [sewaList, setSewaList] = useState<any[]>([])

    const formik = useFormik({
        initialValues: {
            category_name: payload?.category_name || '',
            category_id: payload?.category_id || '',
            name: payload?.name || '',
            email: payload?.email || '',
            contact: payload?.contact || '',
            education: payload?.education || '',
            profesional_career: payload?.profesional_career || '',
            business_organization: payload?.business_organization || '',
            designation: payload?.designation || '',
            social_attributes: payload?.social_attributes || '',
            roles_assigned: payload?.roles_assigned || '',
            office_address: payload?.office_address || '',
            history_of_sewa: payload?.history_of_sewa || '',
            region: payload?.region || '',
            pinCode: payload?.pin_code || '',
            districtName: '',
            stateName: '',
        },
        validationSchema: Yup.object({
            category_id: Yup.string().required('Category is Required'),
            name: Yup.string().required('Dal Name is Required'),
            education: Yup.string().required('Education is Required'),
            email: Yup.string().email("Invalid email format").required("Email is Required"),
            contact: Yup.string().matches(/^[6-9]\d{9}$/, "Enter valid 10-digit number").required("Mobile Number is Required"),
            profesional_career: Yup.string().required('Professional Career is Required'),
            business_organization: Yup.string().required('Business Organization is Required'),
            designation: Yup.string().required('Designation is Required'),
            office_address: Yup.string().required('Address is Required'),
            social_attributes: Yup.string().required('Social Attributes is Required'),
            roles_assigned: Yup.string().required('Roles Assigned is Required'),
            history_of_sewa: Yup.string().required('History of Sewa is Required'),
            region: Yup.string().required('Region is Required'),
            pinCode: Yup.string().trim().matches(/^\d{6}$/, 'Enter 6 Digit Pincode').required('Pincode is required'),
            stateName: Yup.string().matches(/^[A-Za-z\s]+$/, 'InValid State').required('State Name is required'),
            districtName: Yup.string().matches(/^[A-Za-z\s]+$/, 'Invalid District').required('District is required'),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            const reqPayload = {
                category_id: values?.category_id,
                name: values?.name,
                email: values?.email,
                contact: values?.contact,
                education: values?.education,
                profesional_career: values?.profesional_career,
                business_organization: values?.business_organization,
                designation: values?.designation,
                social_attributes: values?.social_attributes,
                roles_assigned: values?.roles_assigned,
                history_of_sewa: values?.history_of_sewa,
                office_address: values?.office_address,
                region: values?.region,
                country_id: 101,
                district_id: values?.districtName,
                state_id: values?.stateName,
                pin_code: values?.pinCode,
                ...(payload?.id && { id: payload?.id }),
            };

            const apiFunction = payload?.id ? SewaDalUpdateService : SewaDalStoreService;
            const { code, message } = await apiFunction(reqPayload);
            if (code === 200) {
                dispatch(showSnackbar({ type: "success", message: message || 'Form Submitted Successfully.' }));
                dispatch(closeDialog());
                dispatch(setModuleRefresh({ moduleName: 'SewaDalRefresh', refresh: true }));
            } else {
                dispatch(showSnackbar({ type: "error", message: message || 'Something Went Wrong!' }));
            }
            setSubmitting(false);
        }
    });

    useEffect(() => {
        fetchSewaCategory();
    }, [])

    const fetchSewaCategory = async () => {
        const { code, data } = await SewaCategoryListService({});
        if (code === 200 && data?.sewa_categories) {
            setSewaList(data?.sewa_categories);
        } else {
            setSewaList([]);
        }
    }


    const fetchPincodeDetails = async (pincode: string) => {
        const { code, data, message } = await GetPincodeDetailsService({
            pincode: Number(pincode),
        });

        if (code === 200) {
            formik.setFieldValue("stateName", data.state || "");
            formik.setFieldValue("districtName", data.district || "");
        } else {
            dispatch(showSnackbar({ type: "error", message: message || "Invalid Pincode", }));
        }
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <GlobalDialogContent
                dialogBody={
                    <Grid container spacing={2}>
                        <Grid item xs={4} >
                            <Autocomplete
                                options={sewaList}
                                getOptionLabel={(option) => option?.category_name || ""}
                                value={sewaList.find(
                                    (item) => item.id === formik.values.category_id
                                ) || null}
                                onChange={(e, value) => {
                                    formik.setFieldValue('category_id', value?.id || '');
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                disableClearable
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        label="Select Sewa Dal *"
                                    />
                                )}
                            />

                        </Grid>
                        <Grid item xs={4} >
                            <TextField
                                fullWidth
                                label="Name of Dal *"
                                name="name"
                                size="small"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                placeholder="Enter Dal Name"
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && Boolean(formik.errors.name)}
                            />
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Email *"
                                name="email"
                                type="email"
                                value={formik.values.email}
                                onChange={(e) => {
                                    formik.setFieldValue('email', e.target.value.toLowerCase());
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && Boolean(formik.errors.email)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Mobile Number *"
                                name="contact"
                                type="text"
                                inputProps={{
                                    maxLength: 10,
                                    pattern: "[0-9]*",
                                    inputMode: "numeric",
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        formik.setFieldValue("contact", value);
                                    }
                                }}
                                value={formik.values.contact}
                                onBlur={formik.handleBlur}
                                error={formik.touched.contact && Boolean(formik.errors.contact)}
                                helperText={formik.touched.contact && Boolean(formik.errors.contact)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Education *"
                                name="education"
                                size="small"
                                value={formik.values.education}
                                onChange={formik.handleChange}
                                placeholder="Enter Education"
                                error={formik.touched.education && Boolean(formik.errors.education)}
                                helperText={formik.touched.education && Boolean(formik.errors.education)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Professional Career *"
                                name="profesional_career"
                                size="small"
                                value={formik.values.profesional_career}
                                onChange={formik.handleChange}
                                placeholder="Enter Professional Career"
                                error={formik.touched.profesional_career && Boolean(formik.errors.profesional_career)}
                                helperText={formik.touched.profesional_career && Boolean(formik.errors.profesional_career)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Business Organization *"
                                name="business_organization"
                                size="small"
                                value={formik.values.business_organization}
                                onChange={formik.handleChange}
                                placeholder="Enter Business Organization"
                                error={formik.touched.business_organization && Boolean(formik.errors.business_organization)}
                                helperText={formik.touched.business_organization && Boolean(formik.errors.business_organization)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Designation *"
                                name="designation"
                                size="small"
                                value={formik.values.designation}
                                onChange={formik.handleChange}
                                placeholder="Enter Designation"
                                error={formik.touched.designation && Boolean(formik.errors.designation)}
                                helperText={formik.touched.designation && Boolean(formik.errors.designation)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Social Attributes *"
                                name="social_attributes"
                                size="small"
                                value={formik.values.social_attributes}
                                onChange={formik.handleChange}
                                placeholder="Enter Social Attributes"
                                error={formik.touched.social_attributes && Boolean(formik.errors.social_attributes)}
                                helperText={formik.touched.social_attributes && Boolean(formik.errors.social_attributes)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Roles Assigned *"
                                name="roles_assigned"
                                size="small"
                                value={formik.values.roles_assigned}
                                onChange={formik.handleChange}
                                placeholder="Enter Roles Assigned"
                                error={formik.touched.roles_assigned && Boolean(formik.errors.roles_assigned)}
                                helperText={formik.touched.roles_assigned && Boolean(formik.errors.roles_assigned)}
                            />
                        </Grid>

                        <Grid item xs={8}>
                            <TextField
                                fullWidth
                                label="History of Sewa *"
                                name="history_of_sewa"
                                size="small"
                                multiline
                                value={formik.values.history_of_sewa}
                                onChange={formik.handleChange}
                                placeholder="Enter History of Sewa"
                                error={formik.touched.history_of_sewa && Boolean(formik.errors.history_of_sewa)}
                                helperText={formik.touched.history_of_sewa && Boolean(formik.errors.history_of_sewa)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Office Address*"
                                name="office_address"
                                size="small"
                                value={formik.values.office_address}
                                onChange={formik.handleChange}
                                placeholder="Enter History of Sewa"
                                error={formik.touched.office_address && Boolean(formik.errors.office_address)}
                                helperText={formik.touched.office_address && Boolean(formik.errors.office_address)}
                            />
                        </Grid>


                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label="Region *"
                                name="region"
                                size="small"
                                value={formik.values.region}
                                onChange={formik.handleChange}
                                placeholder="Enter Region"
                                error={formik.touched.region && Boolean(formik.errors.region)}
                                helperText={formik.touched.region && Boolean(formik.errors.region)}
                            />
                        </Grid>
                        <Grid item xs={3} >
                            <TextField
                                fullWidth
                                size="small"
                                autoComplete='off'
                                label={'Enter Pincode * '}
                                {...formik.getFieldProps("pinCode")}
                                error={Boolean(formik.touched.pinCode && formik.errors.pinCode)}
                                helperText={formik.touched.pinCode && Boolean(formik.errors.pinCode)}
                                inputProps={{
                                    maxLength: 6,
                                    pattern: "[0-9]*",
                                    inputMode: "numeric",
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        formik.setFieldValue("pinCode", value);
                                        if (value.length === 6) {
                                            fetchPincodeDetails(value);
                                        } else {
                                            formik.setFieldValue("stateName", '');
                                            formik.setFieldValue("districtName", '');

                                        }
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={3} >
                            <TextField
                                fullWidth
                                size="small"
                                autoComplete='off'
                                placeholder={'State Name'}
                                {...formik.getFieldProps("stateName")}
                                inputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3} >
                            <TextField
                                fullWidth
                                size="small"
                                autoComplete='off'
                                placeholder={"District Name"}
                                {...formik.getFieldProps("districtName")}
                                inputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                }
                dialogFooter={
                    <Button type="submit" disabled={formik.isSubmitting || !formik.isValid} variant="contained" color="primary" startIcon={<Send />} >
                        {formik.isSubmitting ? payload?.id ? "Updating..." : "Adding..." : payload?.id ? "Update Sewa Dal" : "Add Sewa Dal"}
                    </Button>
                }
            />
        </form>
    )
}

export default AddSewaDal;